<template>
  <div class="layout-videos">

      <slot name="header">
          <div class="uk-section uk-section-medium uk-text-center uk-background-muted page-header">
            <div class="uk-light uk-container uk-container-small uk-text-center">

                <router-link :to="parent.link" v-if="parent && parent.link" class="text-green"><label>{{parent.menuTitle}}</label></router-link>
                <h1 class="uk-margin-small-top">{{page.title}}</h1>

                <slot name="summary">
                    <p class="uk-text-lead" v-if="page.summary">{{page.summary}}</p>
                </slot>

                <slot name="subheader">
                    <ul class="uk-subnav uk-subnav-pill uk-flex-center category-filter uk-margin-medium-top" uk-margin v-if="readVideoCategories.edges && readVideoCategories.edges.length">
                        <li v-bind:class="{ 'uk-active' : activeCategory == 0 }">
                            <a @click.stop="activeCategory=0">All Videos</a>
                        </li>
                        <li v-bind:class="{ 'uk-active' : activeCategory == cat.node.id }"  v-for="cat in readVideoCategories.edges">
                            <a @click.stop="activeCategory = cat.node.id">{{cat.node.title}}</a>
                        </li>
                    </ul>
                </slot>
            </div>
          </div>
      </slot>

        <div class="uk-section uk-background-white uk-section-medium">
            <div class="uk-container">

                <div class="uk-grid  uk-child-width-1-2@s uk-child-width-1-3@m" uk-grid uk-height-match=".uk-card-title">
                    <div v-for="video in filteredVideos" :key="video.urlSegment">
                        <VideoCard :video="video.node" :activeCategory="activeCategory" />
                    </div>
                </div>

            </div>
        </div>

  </div>
</template>

<script>
import VideoCard from '../videos/VideoCard.vue'
import gql from 'graphql-tag'

// GraphQL query
const readVideosQuery = gql`{
  readVideos{
    edges {
      node{
        id
        title
        link
        content
        featuredImage
        category {
            id
            title
        }
      }
    }
  }
}`

const readCategoriesQuery = gql`{
  readVideoCategories{
    edges {
      node{
        id
        title
        link
      }
    }
  }
}`


export default {
    inject: [ 'state', 'theme' ],
    props: ['page', 'parent'],
    data() {
        return {
            activeCategory: 0,
            readVideos: [],
            readVideoCategories: [],
            loading: 0
        }
    },
    components: {
        VideoCard
    },
    apollo: {
        readVideos: {
            // GraphQL query
            query: readVideosQuery,
            // Will update the 'loading' attribute
            // +1 when a new query is loading
            // -1 when a query is completed
            loadingKey: 'loading'
        },
        readVideoCategories: {
            // GraphQL query
            query: readCategoriesQuery,
            // Will update the 'loading' attribute
            // +1 when a new query is loading
            // -1 when a query is completed
            loadingKey: 'loading'
        }
    },
    computed: {
        filteredVideos() {
            if(this.activeCategory==0)
                return this.readVideos.edges

            return this.readVideos.edges.filter(item => {
                return item.node.category.id == this.activeCategory
            })
        }
    }
}
</script>
